module.exports = __webpack_public_path__ + "img/bespoke_img.985a981c.png";